import ConfirmarExclusao from 'global/guides/Dialog/ConfirmarExclusao'
import { useOcorrenciasOutletContext } from 'pages/Ocorrencias.context'
import { useParams } from 'react-router-dom'
import { ocorrencia as api } from 'service/api'
import { toast } from 'sonner'
import { match } from 'ts-pattern'

export default function ExcluirOcorrencia() {
    const { id } = useParams()
    const { data } = useOcorrenciasOutletContext()
    const ocorrencia = data?.find(item => item.id === Number(id))
    const { mutateAsync, isLoading } = api.mutations.useDelete({
        invalidateQuery: true,
    })

    if (!ocorrencia) return null

    const ACAO = (ocorrencia as any).Afastamentos?.length
        ? 'Desativar'
        : 'Excluir'

    const handleSubmit = () =>
        mutateAsync(ocorrencia.id, {
            onSuccess: () => {
                toast.success('Ocorrência removida com sucesso!')
            },
            onError: err => {
                toast.error(err.message)
            },
        })

    return (
        <ConfirmarExclusao
            permissao={['delete', 'Ocorrências']}
            loading={isLoading}
            onConfirm={handleSubmit}
            title={`${ACAO} ocorrência`}
            confirmar={ACAO}
        >
            {match((ocorrencia as any).Afastamentos.length)
                .with(0, () => (
                    <p>
                        Deseja realmente {ACAO.toLowerCase()} a ocorrência{' '}
                        <strong>{ocorrencia.descricao}</strong>? Essa ação é
                        irreversível.
                    </p>
                ))
                .with(1, () => (
                    <p>
                        A ocorrência <strong>{ocorrencia.descricao}</strong>{' '}
                        possui <strong>um</strong> afastamento vinculado. Deseja
                        realmente {ACAO.toLowerCase()}?
                    </p>
                ))
                .otherwise(() => (
                    <p>
                        A ocorrência <strong>{ocorrencia.descricao}</strong>{' '}
                        possui{' '}
                        <strong>
                            {(ocorrencia as any).Afastamentos.length}
                        </strong>{' '}
                        afastamentos vinculados. Deseja realmente{' '}
                        {ACAO.toLowerCase()}?
                    </p>
                ))}
        </ConfirmarExclusao>
    )
}
